module.exports = __webpack_public_path__ + "img/公司介绍W.0b916e1a.svg";